module.exports = __webpack_public_path__ + "static/media/heattherm_at.b2b80ee8.pdf";